import React from 'react';
import ctl from '@netlify/classnames-template-literals';
import Label from 'components/shared/Label/Label';
const LoadingComponent = ({ size = 24, text = 'Loading', hasText = true, className, textClass = 'loading-text', labelClass, children }) => {
    const LoadingComponentCN = ctl(`flex
    items-center
    justify-center
    ${className}`);
    return (React.createElement("div", { className: LoadingComponentCN },
        React.createElement("div", { className: "lds-ring relative inline-block", style: { width: size + 'px', height: size + 'px' } },
            React.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            React.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            React.createElement("div", { style: { width: size + 'px', height: size + 'px' } }),
            React.createElement("div", { style: { width: size + 'px', height: size + 'px' } })),
        text && hasText && (React.createElement("div", { className: textClass },
            React.createElement(Label, { className: labelClass }, text))),
        children && children));
};
export default LoadingComponent;
